<template>
  <div>
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" placeholder="Dynamic bone, ..." v-model="name" />
      </div>
    </div>

    <div class="field">
      <label class="label">Description</label>
      <div class="control">
        <textarea
          class="textarea"
          placeholder="Cool tool to make waffles, ..."
          v-model="description"
        ></textarea>
      </div>
    </div>

    <div class="field">
      <label class="label">Types</label>
      <div class="control">
        <multiselect
          class="multiselect"
          v-model="types"
          :options="typesOptions"
          :searchable="false"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preselectFirst="true"
          placeholder="Pick some"
          track-by="name"
          label="name"
        ></multiselect>
      </div>
    </div>

    <div class="field">
      <label class="label">Plugin</label>
      <div class="file has-name is-boxed is-fullwidth">
        <label class="file-label">
          <input class="file-input" type="file" @change="processPluginFile" />
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">Choose a file (.unitypackage, .zip, ...)…</span>
          </span>
          <span class="file-name">{{pluginFile === null ? "No file." : pluginFile.name}}</span>
        </label>
      </div>
    </div>

    <div class="field">
      <label class="label">Image</label>
      <div class="file has-name is-boxed is-fullwidth">
        <label class="file-label">
          <input class="file-input" type="file" @change="processImageFile" />
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">Choose a file (.png, .jpg, ...)…</span>
          </span>
          <span class="file-name">{{imageFile === null ? "No file." : imageFile.name}}</span>
        </label>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button class="button is-link is-fullwidth" :class="{'is-loading': isUploading}" @click="upload">Edit</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../api";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      name: "",
      description: "",
      types: null,
      typesOptions: [
        { name: "plugin" },
        { name: "model" },
        { name: "personal" }
      ],
      pluginFile: null,
      imageFile: null,
      isUploading: false,
    };
  },
  computed: {
    toSend() {
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      const types = this.types.map(type => type.name)
      for (var i = 0; i < types.length; i++)
        formData.append("types[" + i + "]", types[i]);
      if (this.pluginFile !== null)
        formData.append("plugin", this.pluginFile);
      if (this.imageFile !== null)
        formData.append("image", this.imageFile);
      return formData;
    },
  },
  async created() {
      const pluginCall = await api.getPluginById(this.id)
      const plugin = pluginCall.data
      this.name = plugin.name
      this.description = plugin.description
      this.types = plugin.types.map(type => { return { name: type } })
  },
  methods: {
    processPluginFile(e) {
      this.pluginFile = e.target.files[0];
    },
    processImageFile(e) {
      this.imageFile = e.target.files[0];
    },
    async upload() {
      if (this.isUploading)
        return
      this.isUploading = true
      const res = await api.editPlugin(this.id, this.toSend);
      this.isUploading = false
      this.$router.push("/");
    }
  },
  components: {
    Multiselect
  },
  props: ["id"],
};
</script>
